import { Grid } from '@mui/material';
import { LocalAirport } from '@mui/icons-material';
import styled from '@emotion/styled';
import { theme } from 'config';

export const PlaneWrapper = styled(Grid)(
  {
    width: '100%',
    height: '2px',
    position: 'relative',

    '&::after, &::before': {
      content: '""',
      width: '7px',
      height: '7px',
      borderRadius: '50%',
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
    },

    '&::after': {
      right: '0',
    },
    '&::before': {
      left: '0',
    },

    [theme.breakpoints.down('sm')]: {
      minWidth: '75px',
    },
  },
  ({ canceled }) => ({
    backgroundColor:
      canceled === 'true' ? '#A2A2A1' : theme.palette.secondary.main,

    '&::after, &::before': {
      backgroundColor:
        canceled === 'true' ? '#A2A2A1' : theme.palette.secondary.main,
    },
  })
);

export const IconWrapper = styled(Grid)(
  {
    backgroundColor: '#fff',
    width: 'fit-content',
    position: 'absolute',
    height: '18px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '1',
  },
  ({ left }) => ({
    left: left,
    transform: `translate(-${left}, -50%)`,
  })
);

export const PlaneIcon = styled(LocalAirport)({
  transform: 'rotate(90deg)',
  width: '18px',
  height: '18px',

  [theme.breakpoints.down('sm')]: {},
});
